/* eslint-disable eqeqeq */
import { makeAutoObservable, runInAction } from '../../_snowpack/pkg/mobx.js';
import api from '../api/index.js';
const mapToOptions = options => {
  return options.map(x => ({
    value: x,
    label: x
  }));
};
const accounts = mapToOptions(['FBM', 'FBA', 'Web', 'Test']);
const orderStatuses = mapToOptions(['Unshipped', 'Shipped', 'Completed', 'Processing', 'Return']);
const genders = mapToOptions(['Male', 'Female', 'Unknown']);
const deliveryMethods = [{
  value: 'UpsGround',
  label: 'USP Ground'
}, {
  value: 'UpsPriority',
  label: 'USP Priority'
}, {
  value: 'UspsPriority',
  label: 'USPS Priority'
}, {
  value: 'UspsStandard',
  label: 'USPS Standard'
}, {
  value: 'FedExGround',
  label: 'FedEx Ground'
}, {
  value: 'FedExPriority',
  label: 'FedEx Priority'
}, {
  value: 'Unknown',
  label: 'Unknown'
}];
const ageRanges = [{
  value: '20',
  label: '20s'
}, {
  value: '30',
  label: '30s'
}, {
  value: '40',
  label: '40s'
}, {
  value: '50',
  label: '50s'
}, {
  value: '60',
  label: '60s'
}, {
  value: '70',
  label: '70s'
}, {
  value: '80',
  label: '80+'
}, {
  value: '0',
  label: 'Unknown'
}];
export default class AppStore {
  appLoaded = false;
  enableQuery = false;
  accounts = accounts;
  orderStatuses = orderStatuses;
  deliveryMethods = deliveryMethods;
  ageRanges = ageRanges;
  genders = genders;
  tags = [];
  filter = null;
  sortBy = 'orderDate';
  descending = true;
  page = 1;
  selectedOrderId = null;
  lastSelectedOrderId = null;
  constructor() {
    makeAutoObservable(this);
  }
  setSelectedOrderId = id => {
    this.lastSelectedOrderId = !id ? this.selectedOrderId : null;
    this.selectedOrderId = id;
  };
  setLastSelectedOrderId = id => {
    this.lastSelectedOrderId = id;
  };
  setEnableQuery = () => {
    this.enableQuery = true;
  };
  setPage = page => {
    this.lastSelectedOrderId = null;
    this.selectedOrderId = null;
    this.page = page;
  };
  setSortBy = id => {
    if (this.sortBy == id) {
      this.descending = !this.descending;
    } else {
      this.sortBy = id;
      this.descending = true;
    }
    this.selectedOrderId = null;
  };
  setFilter = filter => {
    if (!this.enableQuery) {
      this.enableQuery = true;
    }
    this.filter = filter;
    this.page = 1;
    this.selectedOrderId = null;
  };
  getFilter = () => {
    return {
      ...this.filter,
      sort: this.sortBy,
      order: this.descending ? 'desc' : 'asc',
      page: this.page
    };
  };
  init = async () => {
    let result = await api.getTags();
    runInAction(() => {
      this.tags = result.map(({
        id,
        name
      }) => ({
        value: id,
        label: name
      }));
      this.appLoaded = true;
    });
  };
}